import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import {
  AuthStrategies,
  NGX_AUTH_OPTIONS,
  NgxAuthOptions,
  OidcOptions,
  provideNgxAuth,
} from '@mds/ngx-auth';
import { API_BASE_URL, UnauthenticatedConfigService } from '@mds/ngx-core';
import { AppInsightsService } from '@mds/ngx-diagnostics';
import { LogLevel } from 'angular-auth-oidc-client';
import { filter, first, map } from 'rxjs';
import { ConfigResponse } from '../shared';

export function provideAuth(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideNgxAuth(),
    {
      provide: NGX_AUTH_OPTIONS,
      useFactory: ngxAuthOptionsFactory,
      deps: [
        UnauthenticatedConfigService<ConfigResponse>,
        API_BASE_URL,
        AppInsightsService,
      ],
    },
  ]);
}

function ngxAuthOptionsFactory(
  configService: UnauthenticatedConfigService<ConfigResponse>,
  baseUrl: string,
  appInsightService: AppInsightsService,
): NgxAuthOptions {
  return {
    appId: 'rpl',
    oidc$: configService.config$.pipe(
      filter((x): x is ConfigResponse => !!x),
      first(),
      map<ConfigResponse, OidcOptions>(
        (c) =>
          ({
            clientId: c.auth.clientId,
            authority: c.auth.issuer,
            redirectUrl: c.auth.redirectUri,
            postLogoutRedirectUrl: c.auth.postLogoutRedirectUrl,
            audience: c.auth.resource,
            secureRoutes: [c.auth.resource, baseUrl],
            logLevel: LogLevel.None,
            renewTimeBeforeTokenExpiresInSeconds: 900,
          }) satisfies OidcOptions,
      ),
    ),
    tenancy: {
      hasBranches: true,
      scopeParameterValuesUrl: `${baseUrl}/v1.0/users/me/scopeparametervalues`,
    },
    unauthorizedUrl: 'error/403',
    logger: appInsightService,
    defaultStrategy: AuthStrategies.Tenancy,
  };
}
